// extracted by mini-css-extract-plugin
export default {"digitInput":"SixDigitInput_digitInput__BeC5y","textFromRight":"SixDigitInput_textFromRight__I5U25"};